import { render } from "./PageHeader.vue?vue&type=template&id=21db6058&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=21db6058&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-21db6058"

export default script